export const updateWager = (e) => (dispatch, getState) => {
    let str = e.target.value;
    dispatch({type: 'UPDATE_WAGER',str});
}

export const updatePayout = (e) => (dispatch, getState) => {
    let str = e.target.value;
    dispatch({type: 'UPDATE_PAYOUT', str});
}

export const setNextHash = () => (dispatch) => {
    dispatch({type: 'SET_NEXT_HASH'});
}


// WEBPACK FOOTER //
// ./src/actions/bet.js